export default "__VITE_ASSET__Lw82Jjew__"